"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultDashboards = exports.DEFAULT_DASHBOARD = exports.DB_TYPE = exports.FILTER_OPERATOR = exports.PIVOT_TYPE = exports.QUERY_TYPE = exports.AGGREGATOR_DIMENSION = exports.AGGREGATOR = exports.AXIS_TYPE = exports.KPI_TYPE = exports.DASHBOARD_SCOPE = exports.DASHBOARD_TYPE = void 0;
const tools_1 = require("../tools");
/**
 * Type of Dashboard
 */
var DASHBOARD_TYPE;
(function (DASHBOARD_TYPE) {
    DASHBOARD_TYPE["MOBILE"] = "MOBILE";
    DASHBOARD_TYPE["MOBILE_ON_LIST"] = "MOBILE_ON_LIST";
    DASHBOARD_TYPE["WEB"] = "WEB";
    DASHBOARD_TYPE["MOBILE_AND_WEB"] = "MOBILE_AND_WEB";
})(DASHBOARD_TYPE = exports.DASHBOARD_TYPE || (exports.DASHBOARD_TYPE = {}));
/**
 * Dashboard scope
 */
var DASHBOARD_SCOPE;
(function (DASHBOARD_SCOPE) {
    DASHBOARD_SCOPE["GLOBAL"] = "GLOBAL";
    DASHBOARD_SCOPE["TEAM"] = "TEAM";
})(DASHBOARD_SCOPE = exports.DASHBOARD_SCOPE || (exports.DASHBOARD_SCOPE = {}));
/**
 * Type of KPI
 */
var KPI_TYPE;
(function (KPI_TYPE) {
    KPI_TYPE["LINE_CHART"] = "LINE_CHART";
    KPI_TYPE["SCORECARD"] = "SCORECARD";
    KPI_TYPE["GAUGE"] = "GAUGE";
    KPI_TYPE["PIE_CHART"] = "PIE_CHART";
    KPI_TYPE["BAR_CHART"] = "BAR_CHART";
    KPI_TYPE["BAR_CHART_HORIZONTAL"] = "BAR_CHART_HORIZONTAL";
    KPI_TYPE["STACKED_BAR_CHART"] = "STACKED_BAR_CHART";
    KPI_TYPE["MULTIPLE_LINE_CHART"] = "MULTIPLE_LINE_CHART";
    KPI_TYPE["HEATMAP_CHART"] = "HEATMAP_CHART";
    KPI_TYPE["CALENDAR_CHART"] = "CALENDAR_CHART";
    KPI_TYPE["SCATTER_PLOT_CHART"] = "SCATTER_PLOT_CHART";
    KPI_TYPE["MAP"] = "MAP";
    KPI_TYPE["TABLE"] = "TABLE";
    KPI_TYPE["MATRIX"] = "MATRIX";
    KPI_TYPE["CAROUSEL"] = "CAROUSEL";
    KPI_TYPE["TIMELINE"] = "TIMELINE";
})(KPI_TYPE = exports.KPI_TYPE || (exports.KPI_TYPE = {}));
/**
 * Type of the axis
 */
var AXIS_TYPE;
(function (AXIS_TYPE) {
    AXIS_TYPE["TEXT"] = "TEXT";
    AXIS_TYPE["TIME"] = "TIME";
    AXIS_TYPE["NUMBER"] = "NUMBER";
})(AXIS_TYPE = exports.AXIS_TYPE || (exports.AXIS_TYPE = {}));
/**
 * Aggregator operation
 */
var AGGREGATOR;
(function (AGGREGATOR) {
    AGGREGATOR["COUNT"] = "COUNT";
    AGGREGATOR["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    AGGREGATOR["SUM"] = "SUM";
    AGGREGATOR["MEAN"] = "MEAN";
    AGGREGATOR["MIN"] = "MIN";
    AGGREGATOR["MAX"] = "MAX";
    AGGREGATOR["NONE"] = "NONE";
    AGGREGATOR["BOOLEAN"] = "BOOLEAN";
    AGGREGATOR["PERCENTAGE"] = "PERCENTAGE";
})(AGGREGATOR = exports.AGGREGATOR || (exports.AGGREGATOR = {}));
var AGGREGATOR_DIMENSION;
(function (AGGREGATOR_DIMENSION) {
    AGGREGATOR_DIMENSION["COLUMN"] = "COLUMN";
    AGGREGATOR_DIMENSION["ROW"] = "ROW";
})(AGGREGATOR_DIMENSION = exports.AGGREGATOR_DIMENSION || (exports.AGGREGATOR_DIMENSION = {}));
/**
 * Type of the subquery (for TABLE type) => not used yet
 */
var QUERY_TYPE;
(function (QUERY_TYPE) {
    QUERY_TYPE["NUMERIC"] = "NUMERIC";
    QUERY_TYPE["TEXT"] = "TEXT";
    QUERY_TYPE["PERCENTAGE"] = "PERCENTAGE";
})(QUERY_TYPE = exports.QUERY_TYPE || (exports.QUERY_TYPE = {}));
var PIVOT_TYPE;
(function (PIVOT_TYPE) {
    PIVOT_TYPE["MOBILE_USER"] = "MOBILE_USER";
    PIVOT_TYPE["TEAM"] = "TEAM";
    PIVOT_TYPE["DATE"] = "DATE";
    PIVOT_TYPE["CUSTOM"] = "CUSTOM";
    PIVOT_TYPE["NONE"] = "NONE";
})(PIVOT_TYPE = exports.PIVOT_TYPE || (exports.PIVOT_TYPE = {}));
var FILTER_OPERATOR;
(function (FILTER_OPERATOR) {
    FILTER_OPERATOR["EQUAL"] = "EQUAL";
    FILTER_OPERATOR["DIFFERENT"] = "DIFFERENT";
    FILTER_OPERATOR["CONTAINS"] = "CONTAINS";
    FILTER_OPERATOR["NOT_CONTAINS"] = "NOT_CONTAINS";
    FILTER_OPERATOR["LESS_THAN"] = "LESS_THAN";
    FILTER_OPERATOR["MORE_THAN"] = "MORE_THAN";
})(FILTER_OPERATOR = exports.FILTER_OPERATOR || (exports.FILTER_OPERATOR = {}));
var DB_TYPE;
(function (DB_TYPE) {
    DB_TYPE["BIGQUERY"] = "BIGQUERY";
    DB_TYPE["POSTGRES"] = "POSTGRES";
    DB_TYPE["REDSHIFT"] = "REDSHIFT";
    DB_TYPE["MSSQL"] = "MSSQL";
    DB_TYPE["OPTIMETRIKS"] = "OPTIMETRIKS";
})(DB_TYPE = exports.DB_TYPE || (exports.DB_TYPE = {}));
var DEFAULT_DASHBOARD;
(function (DEFAULT_DASHBOARD) {
    DEFAULT_DASHBOARD["GPS_TRACKING"] = "_gps_tracking";
    DEFAULT_DASHBOARD["RECAP_REPORT"] = "_recap_report";
    DEFAULT_DASHBOARD["BILLING_REPORT"] = "_billing_report";
    DEFAULT_DASHBOARD["CLIENT_ACTIVITY"] = "_client_activity";
    DEFAULT_DASHBOARD["MONTHLY_SUBMISSIONS"] = "_monthly_submissions";
    DEFAULT_DASHBOARD["WEEKLY_SUBMISSIONS"] = "_weekly_submissions";
    DEFAULT_DASHBOARD["LOG_REPORT"] = "_log_report";
    DEFAULT_DASHBOARD["JOB_LOG_REPORT"] = "_job_log_report";
    DEFAULT_DASHBOARD["SUBMISSION_REPORT"] = "_submission_report";
    DEFAULT_DASHBOARD["ACTIVITY_ITEMS"] = "_activities_items";
    DEFAULT_DASHBOARD["ACTIVITY_SUBMISSIONS"] = "_activities_submissions";
    DEFAULT_DASHBOARD["ACTIVITY_PICTURES"] = "_activities_pictures";
    DEFAULT_DASHBOARD["LIST_ANALYSIS"] = "_list_analysis";
    DEFAULT_DASHBOARD["TEAM_ANALYSIS"] = "_team_analysis";
    DEFAULT_DASHBOARD["DATABASE_STRUCTURE"] = "_database_structure";
    DEFAULT_DASHBOARD["MASTER_USER_LIST"] = "_master_user_list";
    DEFAULT_DASHBOARD["INTERNAL_WEB_USER_ACCESS"] = "_internal_web_user_access";
})(DEFAULT_DASHBOARD = exports.DEFAULT_DASHBOARD || (exports.DEFAULT_DASHBOARD = {}));
const getDefaultDashboards = (clientId) => [
    {
        title: "GPS tracking",
        type: DASHBOARD_TYPE.WEB,
        description: ".",
        locked: true,
        folder: "GPS Tracking",
        kpis: [
            {
                type: KPI_TYPE.MAP,
                description: "",
                sub_queries: [
                    {
                        label: "gps_records",
                        query: "SELECT user_id, lat, lng, acc, timestamp FROM mobile_user_location WHERE $date_filter:timestamp$ AND $users_filter:user_id$",
                    },
                    {
                        label: "places_visited",
                        query: "SELECT 0",
                    },
                    {
                        label: "timeline_actions",
                        query: "SELECT 0",
                    },
                ],
                index: 0,
                title: "GPS tracking",
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        id: DEFAULT_DASHBOARD.GPS_TRACKING,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Logs",
        type: DASHBOARD_TYPE.WEB,
        description: ".",
        locked: true,
        kpis: [
            {
                type: KPI_TYPE.TABLE,
                description: "",
                query: "SELECT 0",
                title: "Logs",
                index: 0,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        id: DEFAULT_DASHBOARD.LOG_REPORT,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Submissions",
        type: DASHBOARD_TYPE.WEB,
        description: ".",
        locked: true,
        kpis: [
            {
                type: KPI_TYPE.TABLE,
                description: "",
                query: "SELECT _id, _user_name, _user_phone, _completed_at FROM $param1$ WHERE $date_filter:_completed_at$ ORDER BY _completed_at DESC NULLS LAST",
                title: "Submissions",
                index: 0,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        id: DEFAULT_DASHBOARD.SUBMISSION_REPORT,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Job Logs",
        type: DASHBOARD_TYPE.WEB,
        description: ".",
        locked: true,
        kpis: [
            {
                type: KPI_TYPE.STACKED_BAR_CHART,
                description: "",
                title: "Jobs per day",
                x_axis_type: AXIS_TYPE.TIME,
                row_query: `
        SELECT
          'SUCCESS' as label,
          'SUCCESS' as value
        UNION
        SELECT
          'FAILURE' as label,
          'FAILURE' as value;`,
                query: `
        select
          count(*) as y,
          started_at as x
        from
          job_log
        where
          $date_filter:started_at$
          and status = $row_query_result$
        group by
          started_at
        `,
                full_width: false,
                index: 0,
                id: tools_1.IDSource(),
            },
            {
                type: KPI_TYPE.PIE_CHART,
                description: "",
                query: `
        SELECT
          count(*) as y,
          type as x
        from
          job_log
        where $date_filter:started_at$
        group by
          type`,
                title: "Jobs per type",
                full_width: false,
                index: 1,
                id: tools_1.IDSource(),
            },
            {
                type: KPI_TYPE.TABLE,
                description: "",
                query: `
        select
          *
        from
          job_log where $date_filter:started_at$`,
                title: "All job logs",
                full_width: true,
                index: 2,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        id: DEFAULT_DASHBOARD.JOB_LOG_REPORT,
        folder: "Job logs",
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Recap report",
        type: DASHBOARD_TYPE.WEB,
        description: ".",
        locked: true,
        folder: "Recap",
        kpis: [
            {
                type: KPI_TYPE.TABLE,
                full_width: true,
                description: "",
                query: "SELECT 0",
                title: "Recap report",
                index: 0,
                id: tools_1.IDSource(),
            },
            {
                type: KPI_TYPE.TABLE,
                full_width: true,
                description: "",
                query: "SELECT 0",
                title: "Recap report - Live clients",
                index: 1,
                id: tools_1.IDSource(),
            },
            {
                type: KPI_TYPE.TABLE,
                full_width: true,
                description: "",
                query: "SELECT 0",
                title: "Recap report - Trial clients",
                index: 2,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        id: DEFAULT_DASHBOARD.RECAP_REPORT,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Billing report",
        type: DASHBOARD_TYPE.WEB,
        description: ".",
        locked: true,
        folder: "Recap",
        kpis: [
            {
                type: KPI_TYPE.TABLE,
                full_width: true,
                description: "all admin and finance related info",
                query: "SELECT 0",
                title: "Billing report",
                index: 0,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        id: DEFAULT_DASHBOARD.BILLING_REPORT,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Client activity",
        type: DASHBOARD_TYPE.WEB,
        description: ".",
        locked: true,
        folder: "Recap",
        kpis: [
            {
                type: KPI_TYPE.TABLE,
                full_width: true,
                description: "",
                query: "SELECT 0",
                title: "Client activity",
                index: 0,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        id: DEFAULT_DASHBOARD.CLIENT_ACTIVITY,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Monthly KPIs",
        description: ".",
        type: DASHBOARD_TYPE.WEB,
        locked: true,
        folder: "Recap",
        kpis: [
            {
                query: `SELECT 0`,
                type: KPI_TYPE.BAR_CHART,
                title: "Monthly number of submissions",
                description: ".",
                index: 0,
                full_width: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.BAR_CHART,
                title: "Submission / user",
                description: ".",
                index: 1,
                full_width: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.BAR_CHART,
                title: "Number of active users",
                description: ".",
                index: 2,
                full_width: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.BAR_CHART,
                title: "% active users",
                description: ".",
                index: 3,
                full_width: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.SCORECARD,
                title: "Nb clients on Go live",
                description: ".",
                index: 4,
                full_width: false,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.SCORECARD,
                title: "Nb clients on Trial",
                description: ".",
                index: 5,
                full_width: false,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.STACKED_BAR_CHART,
                title: "Live vs Pilot",
                description: ".",
                index: 6,
                full_width: false,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        db_type: DB_TYPE.OPTIMETRIKS,
        id: DEFAULT_DASHBOARD.MONTHLY_SUBMISSIONS,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Weekly KPIs",
        description: ".",
        type: DASHBOARD_TYPE.WEB,
        locked: true,
        folder: "Recap",
        kpis: [
            {
                query: `SELECT 0`,
                type: KPI_TYPE.BAR_CHART,
                title: "Weekly number of submissions",
                description: ".",
                index: 0,
                full_width: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.BAR_CHART,
                title: "Submission / user",
                description: ".",
                index: 1,
                full_width: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.BAR_CHART,
                title: "Number of active users",
                description: ".",
                index: 2,
                full_width: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.BAR_CHART,
                title: "% active users",
                description: ".",
                index: 3,
                full_width: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.SCORECARD,
                title: "Nb clients on Go live",
                description: ".",
                index: 4,
                full_width: false,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.SCORECARD,
                title: "Nb clients on Trial",
                description: ".",
                index: 5,
                full_width: false,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.STACKED_BAR_CHART,
                title: "Live vs Pilot",
                description: ".",
                index: 6,
                full_width: false,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
        ],
        db_type: DB_TYPE.OPTIMETRIKS,
        id: DEFAULT_DASHBOARD.WEEKLY_SUBMISSIONS,
        actif: true,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Items",
        description: "item activity",
        type: DASHBOARD_TYPE.MOBILE,
        locked: true,
        kpis: [
            {
                type: KPI_TYPE.MULTIPLE_LINE_CHART,
                title: "Items",
                index: 0,
                full_width: false,
                is_filled: true,
                x_axis_type: AXIS_TYPE.TIME,
                aggregator: AGGREGATOR.SUM,
                is_percentage: false,
                description: ".",
                sub_queries: [
                    {
                        query: `
            SELECT
            timestamp as x,
            1 as y
            FROM
            log_all
            WHERE
            action_code = 'CREATE_ITEM'
            AND system_action != true
            AND $users_filter:user_id$
            AND $date_filter:timestamp$
            AND status = 'SUCC';`,
                        label: "Items created",
                    },
                    {
                        query: `
            SELECT
            timestamp as x,
            1 as y
            FROM
            log_all
            WHERE
            action_code = 'EDIT_ITEM'
            AND system_action != true
            AND $users_filter:user_id$
            AND $date_filter:timestamp$
            AND status = 'SUCC';`,
                        label: "Items edited",
                    },
                ],
                id: "plvbux3nc1q1br8k",
            },
        ],
        db_type: DB_TYPE.OPTIMETRIKS,
        id: DEFAULT_DASHBOARD.ACTIVITY_ITEMS,
        actif: true,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
        time_ranges: [],
    },
    {
        title: "Submissions",
        description: ".",
        type: DASHBOARD_TYPE.MOBILE,
        locked: true,
        kpis: [
            {
                query: `SELECT
				timestamp as x,
				1 as y,
				action_code
			FROM
				log_all
			WHERE
				action_code = 'CREATE_SUBMISSION'
				AND $users_filter:user_id$
				AND $date_filter:timestamp$;`,
                type: KPI_TYPE.LINE_CHART,
                description: "",
                title: "Total submissions",
                index: 0,
                full_width: false,
                is_filled: false,
                x_axis_type: AXIS_TYPE.TIME,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT
				timestamp as x,
				1 as y
			from
        (SELECT * FROM log_all WHERE $users_filter:user_id$) t
      WHERE
        action_code = 'CREATE_SUBMISSION'
        AND workflow_id IN ($row_query_result$)
        AND $date_filter:timestamp$;`,
                type: KPI_TYPE.STACKED_BAR_CHART,
                title: "Submissions per workflows",
                description: ".",
                index: 1,
                full_width: false,
                is_filled: false,
                x_axis_type: AXIS_TYPE.TIME,
                row_query: "SELECT name as label, id as value FROM workflows WHERE actif = true;",
                aggregator: AGGREGATOR.SUM,
                is_percentage: false,
                target: 0,
                max_value: 100,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT
				count(l.action_code) as value,
				w.name as label
			FROM
				(
					SELECT
						*
					from
						log_all
					WHERE
						action_code = 'CREATE_SUBMISSION'
						AND workflow_id IS NOT NULL
						AND $date_filter:timestamp$
						AND $users_filter:user_id$
						AND system_action != TRUE
				) l FULL
				OUTER JOIN (
					SELECT
						*
					FROM
						workflows
					WHERE
						actif = TRUE
				) w ON (l.workflow_id = w.id)
			GROUP BY
				(name);`,
                type: KPI_TYPE.PIE_CHART,
                title: "Percentage of workflow",
                description: ".",
                index: 2,
                full_width: false,
                is_filled: false,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                is_percentage: false,
                target: 0,
                max_value: 100,
                id: tools_1.IDSource(),
            },
        ],
        db_type: DB_TYPE.OPTIMETRIKS,
        id: DEFAULT_DASHBOARD.ACTIVITY_SUBMISSIONS,
        actif: true,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
        time_ranges: [],
    },
    {
        title: "Pictures",
        description: ".",
        type: DASHBOARD_TYPE.MOBILE,
        locked: true,
        kpis: [
            {
                query: `SELECT
        COUNT(DISTINCT url) as y,
        created_at as x
      FROM
        uploads
      WHERE
        (
          action = 'UPLOAD_FILE_FOR_SUBMISSION'
          OR action = 'UPLOAD_FILE_FOR_ITEM'
        )
        AND $users_filter:user_id$
        AND $date_filter:created_at$
      GROUP BY
        created_at;`,
                type: KPI_TYPE.LINE_CHART,
                title: "Pictures taken per day",
                description: ".",
                index: 0,
                full_width: false,
                is_filled: false,
                x_axis_type: AXIS_TYPE.TIME,
                aggregator: AGGREGATOR.SUM,
                is_percentage: false,
                target: 0,
                max_value: 100,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT
        url
      FROM
        uploads
      WHERE
        (
          action = 'UPLOAD_FILE_FOR_SUBMISSION'
          OR action = 'UPLOAD_FILE_FOR_ITEM'
        )
        AND $users_filter:user_id$
        AND $date_filter:created_at$;`,
                type: KPI_TYPE.CAROUSEL,
                description: "",
                title: "Pictures",
                index: 1,
                id: tools_1.IDSource(),
            },
        ],
        db_type: DB_TYPE.OPTIMETRIKS,
        id: DEFAULT_DASHBOARD.ACTIVITY_PICTURES,
        actif: true,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
        time_ranges: [],
    },
    {
        title: "Database Structure",
        description: ".",
        type: DASHBOARD_TYPE.WEB,
        kpis: [
            {
                type: KPI_TYPE.TABLE,
                description: ".",
                query: `WITH res1 as (select *,
          table_name as table_id,
        CASE
          WHEN table_name LIKE 'teams\\_%' OR
                 table_name LIKE 'items\\_%' OR
                 table_name LIKE 'workflows\\_%' OR
                 table_name LIKE 'mobile_users\\_%' OR
			  	 table_name LIKE 'w\\_%\\_%' OR
			     table_name LIKE 'l\\_%\\_%' OR
                 table_name LIKE 'web_users\\_%' THEN 'STRUCTURE'
		  WHEN table_name IN ('lists','place','sku','distributor','asset','vendor') OR table_name LIKE 'l\\_%' THEN 'LIST'
          WHEN table_name LIKE 'w\\_%' or table_name IN ('workflows','outdated_workflows') THEN 'WORKFLOW'
          WHEN table_name='teams' THEN 'TEAM'
          WHEN table_name='email_generations' THEN 'EMAILGENERATION'
          WHEN table_name='dashboards' THEN 'DASHBOARD'
          WHEN table_name='transformations' THEN 'TRANSFORMATION'
          WHEN table_name='streams' THEN 'STREAM'
          WHEN table_name='documents' THEN 'DOCUMENT'
          WHEN table_name='picture_analysis' THEN 'ALGO'
          WHEN table_name IN ('web_users','mobile_users') THEN 'USER'
          WHEN table_name LIKE '%log%' THEN 'LOG'
          ELSE 'OTHER'
       END table_type,
       (xpath('/row/cnt/text()', xml_count))[1]::text::int as nb_lines,
        CASE
         WHEN table_name LIKE 'w\\_%' AND Table_name NOT LIKE 'w\\_%\\_%'  
			  THEN (SELECT workflows.actif from public.workflows WHERE id=trim(leading 'w_' from table_name))
         WHEN table_name IN ('place','sku','distributor','asset','vendor') THEN (SELECT lists.actif from public.lists WHERE id=table_name)
         WHEN table_name LIKE 'l\\_%' AND Table_name NOT LIKE 'l\\_%\\_%' AND trim(leading 'l_' from table_name) IN (SELECT id FROM public.lists)
			  THEN (SELECT lists.actif from public.lists WHERE id=trim(leading 'l_' from table_name))
         ELSE TRUE
     END active,
     CASE
         WHEN table_name LIKE 'w\\_%' AND Table_name NOT LIKE 'w\\_%\\_%'
			  THEN (SELECT COALESCE(workflows.data::json->>'scope','GLOBAL') from public.workflows WHERE id=trim(leading 'w_' from table_name))
         WHEN table_name IN ('place','sku','distributor','asset','vendor') THEN (SELECT lists.data::json->>'scope' from public.lists WHERE id=table_name)
         WHEN table_name LIKE 'l\\_%' AND Table_name NOT LIKE 'l\\_%\\_%' AND trim(leading 'l_' from table_name) IN (SELECT id FROM public.lists)
			  THEN (SELECT COALESCE(lists.data::json->>'scope','') from public.lists WHERE id=trim(leading 'l_' from table_name))
         ELSE ''
     END scope
   from (
     select table_name, table_schema, 
            query_to_xml(format('select count(*) as cnt from %I.%I', table_schema, table_name), false, true, '') as xml_count
     from information_schema.tables
     where table_schema = 'public'
   ) tab ORDER BY table_id)
   SELECT table_id,table_type,nb_lines,active,scope
       from res1;
   `,
                title: "Tables details",
                full_width: true,
                index: 0,
                id: tools_1.IDSource(),
            },
            {
                type: KPI_TYPE.TABLE,
                description: ".",
                query: `WITH unnested_confkey AS (
          SELECT oid, unnest(confkey) as confkey
          FROM pg_constraint
        ),
         unnested_conkey AS (
          SELECT oid, unnest(conkey) as conkey
          FROM pg_constraint
        ),
         res AS (select
          tbl.relname              "Table 1 ID",
	      referenced_tbl.relname   "Table 2 ID",
          col.attname              "Link Variable Table 1",
		  referenced_field.attname "Link Variable Table 2"
        FROM pg_constraint c
        LEFT JOIN unnested_conkey con ON c.oid = con.oid
        LEFT JOIN pg_class tbl ON tbl.oid = c.conrelid
        LEFT JOIN pg_attribute col ON (col.attrelid = tbl.oid AND col.attnum = con.conkey)
        LEFT JOIN pg_class referenced_tbl ON c.confrelid = referenced_tbl.oid
        LEFT JOIN unnested_confkey conf ON c.oid = conf.oid
        LEFT JOIN pg_attribute referenced_field ON (referenced_field.attrelid = c.confrelid AND referenced_field.attnum = conf.confkey)
        WHERE c.contype = 'f')
		SELECT * from res;`,
                title: "Tables links",
                full_width: true,
                index: 1,
                id: tools_1.IDSource(),
            },
            {
                type: KPI_TYPE.TABLE,
                description: ".",
                query: "SELECT 1;",
                title: "Variables",
                index: 2,
                full_width: true,
                id: tools_1.IDSource(),
            },
        ],
        db_type: DB_TYPE.OPTIMETRIKS,
        id: DEFAULT_DASHBOARD.DATABASE_STRUCTURE,
        actif: true,
        folder: "Database structure",
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Master user list",
        description: ".",
        type: DASHBOARD_TYPE.WEB,
        locked: true,
        folder: "Recap",
        kpis: [
            {
                query: `SELECT 0`,
                type: KPI_TYPE.TABLE,
                title: "Mobile users",
                description: ".",
                index: 0,
                full_width: true,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.TABLE,
                title: "Web users",
                description: ".",
                index: 1,
                full_width: true,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        db_type: DB_TYPE.OPTIMETRIKS,
        id: DEFAULT_DASHBOARD.MASTER_USER_LIST,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        title: "Internal Web User Access ",
        description: ".",
        type: DASHBOARD_TYPE.WEB,
        locked: true,
        folder: "Recap",
        kpis: [
            {
                query: `SELECT 0`,
                type: KPI_TYPE.TABLE,
                title: "Access per DB",
                description: ".",
                index: 0,
                full_width: true,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
            {
                query: `SELECT 0`,
                type: KPI_TYPE.TABLE,
                title: "Internal web user",
                description: ".",
                index: 1,
                full_width: true,
                x_axis_type: AXIS_TYPE.TEXT,
                aggregator: AGGREGATOR.SUM,
                id: tools_1.IDSource(),
            },
        ],
        actif: true,
        db_type: DB_TYPE.OPTIMETRIKS,
        id: DEFAULT_DASHBOARD.INTERNAL_WEB_USER_ACCESS,
        client_id: clientId,
        created_at: new Date(),
        updated_at: new Date(),
    },
];
exports.getDefaultDashboards = getDefaultDashboards;
